import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/fb.png'
import _imports_1 from '@/assets/icon/insta.png'


const _withScopeId = n => (_pushScopeId("data-v-47926284"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", { "aria-label": "Social Bar" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "social-link" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.facebook.com/VelvetManGod",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "Facebook - White Circle",
          src: _imports_0
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "social-link" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "http://instagram.com/VelvetManGod",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          alt: "Instagram - White Circle",
          src: _imports_1
        })
      ])
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy" }, [
  /*#__PURE__*/_createElementVNode("p", null, "© 2021 Velvet Man God")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}